export default "__VITE_ASSET__yrhWxAwK__"